export const PRODUCT_OPTIONS = [
  { key: "enterprise", label: "Enterprise (franchise network)" },
  { key: "nyafaz_salon", label: "Nyafaz Salon (single salon)" },
  { key: "nyafaz_brand", label: "Nyafaz Brand" },
];

/** API may return `naturals`; portal UI uses `enterprise` for the same franchise network product. */
export function normalizePortalProductKey(key) {
  const k = String(key || "").trim().toLowerCase();
  if (k === "naturals" || k === "enterprise") return "enterprise";
  return k;
}

export function isFranchiseNetworkOrg(org) {
  return orgEnabledProducts(org).includes("enterprise");
}

export const SERVICE_OPTIONS = [
  { key: "skin_analysis", label: "Skin analysis" },
  { key: "hair_analysis", label: "Hair analysis" },
  { key: "hair_style", label: "Hair style" },
  { key: "makeup", label: "Makeup" },
  { key: "hair_coloring", label: "Hair coloring" },
  { key: "reels", label: "Reels" },
  { key: "customer_engagement", label: "Customer engagement" },
  { key: "whatsapp", label: "WhatsApp" },
];

const BRAND_BLOCKED = new Set(["hair_analysis", "hair_style", "hair_coloring"]);
const LEGACY_SERVICE_KEYS = new Set(["video_editor"]);

const ANALYSIS_SERVICE_KEYS = SERVICE_OPTIONS.map((s) => s.key);

/** Skin / hair / studio services billed under the Analyze and Studio plan family. */
export const ANALYSIS_ORG_SERVICE_KEYS = [
  "skin_analysis",
  "hair_analysis",
  "hair_style",
  "makeup",
  "hair_coloring",
];

export function orgHasAnalysisServices(services) {
  const set = new Set((services || []).map((s) => normalizeServiceKey(s)));
  return ANALYSIS_ORG_SERVICE_KEYS.some((key) => set.has(key));
}

export function orgHasEngagementService(services) {
  return (services || []).map((s) => normalizeServiceKey(s)).includes("customer_engagement");
}

const normalizeServiceKey = (key) => {
  const k = String(key || "").trim().toLowerCase();
  if (LEGACY_SERVICE_KEYS.has(k)) return "reels";
  return k;
};

export const defaultServicesForProduct = (product) => {
  const p = normalizePortalProductKey(product);
  if (p === "nyafaz_brand") {
    return ["skin_analysis", "makeup", "reels"];
  }
  return [...ANALYSIS_SERVICE_KEYS];
};

export const servicesForProduct = (product) => {
  return SERVICE_OPTIONS.filter((s) => {
    if (product === "nyafaz_brand" && BRAND_BLOCKED.has(s.key)) return false;
    return true;
  });
};

export const orgEnabledProducts = (org) => {
  const raw = org?.enabledProducts || org?.enabled_products;
  if (Array.isArray(raw) && raw.length) {
    return raw.map(normalizePortalProductKey).filter(Boolean);
  }
  const pt = normalizePortalProductKey(org?.productType || org?.product_type || "enterprise");
  return [pt];
};

export const defaultServicesForProducts = (products) => {
  const merged = [];
  const seen = new Set();
  (products || []).forEach((p) => {
    defaultServicesForProduct(p).forEach((s) => {
      const key = normalizeServiceKey(s);
      if (!seen.has(key)) {
        seen.add(key);
        merged.push(key);
      }
    });
  });
  if (merged.includes("customer_engagement") && !merged.includes("whatsapp")) {
    merged.push("whatsapp");
  }
  return merged;
};

export const servicesForProducts = (products) => {
  const keys = products || [];
  if (!keys.length) return [];
  const allowBrand = keys.includes("nyafaz_brand");
  const allowAll = keys.includes("enterprise") || keys.includes("nyafaz_salon");
  return SERVICE_OPTIONS.filter((s) => {
    if (allowBrand && BRAND_BLOCKED.has(s.key) && !allowAll) return false;
    if (keys.length === 1 && keys[0] === "nyafaz_brand" && BRAND_BLOCKED.has(s.key)) return false;
    return true;
  });
};

export const productLabel = (key) =>
  PRODUCT_OPTIONS.find((p) => p.key === key)?.label || key;

export const serviceLabel = (key) => {
  const normalized = normalizeServiceKey(key);
  return SERVICE_OPTIONS.find((s) => s.key === normalized)?.label || key;
};
